module.exports = __webpack_public_path__ + "media/3.30c4b554.mp3";